// Keep Shopify's file input, accessible name, upload and validation untouched.
// Match the observed file-field structure rather than generated app class names.
const fileField = 'div:has(> p:first-child + div > label > input[type="file"])';
const uploadStyles = `
  ${fileField} {
    display: grid;
  }
  ${fileField} > p:first-child {
    grid-area: 1 / 1;
    align-self: center;
    justify-self: center;
    z-index: 1;
    margin: 0;
    padding: 12px;
    max-width: 100%;
    font: var(--forms-body-font);
    font-size: 12px;
    line-height: 20px;
    color: #616161;
    text-align: center;
    pointer-events: none;
  }
  ${fileField} > p:first-child + div {
    grid-area: 1 / 1;
    margin-top: 0;
  }
  ${fileField} > p:first-child + div:not(:has(button)) > div > span {
    visibility: hidden;
  }
  ${fileField}:has(> p:first-child + div button) > p:first-child {
    display: none;
  }
  /* The caption must not determine the width of the whole mobile form. */
  @media (max-width: 490px) {
    div:has(> #form-container-ref) {
      justify-content: stretch;
    }
  }
`;

class VoidScreenContactUpload extends HTMLElement {
  connectedCallback() {
    if (!CSS.supports('selector(:has(*))')) return;
    clearTimeout(this.retryTimer);
    let attempts = 120;

    const enhance = () => {
      if (!this.isConnected) return;
      const root = this.querySelector('shopify-forms-embed')?.shadowRoot;

      // Wait for the app's mounted form. If its markup changes or loading fails,
      // leave the native presentation intact instead of hiding the uploader.
      if (root?.querySelector(fileField)) {
        if (!root.querySelector('style[data-voidscreen-upload]')) {
          const style = document.createElement('style');
          style.dataset.voidscreenUpload = '';
          style.textContent = uploadStyles;
          root.append(style);
        }
        return;
      }

      if (--attempts > 0) this.retryTimer = setTimeout(enhance, 250);
    };

    enhance();
  }

  disconnectedCallback() {
    clearTimeout(this.retryTimer);
  }
}

if (!customElements.get('voidscreen-contact-upload')) {
  customElements.define('voidscreen-contact-upload', VoidScreenContactUpload);
}
